import React from 'react';
import { IconSvgProps } from '@models/common';

const NavExpertHelp: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M5 10.375v6.011c0 .36 0 .539.055.697a1 1 0 0 0 .23.374c.118.12.278.2.6.36l5.4 2.7c.262.131.393.197.53.223a.998.998 0 0 0 .37 0c.137-.026.268-.092.53-.223l5.4-2.7c.322-.16.482-.24.6-.36a1 1 0 0 0 .23-.374c.055-.158.055-.338.055-.697v-6.011m-17-1.5 9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 0 1 .184 0c.069.012.135.045.266.11L22 8.876l-9.642 4.821a1.087 1.087 0 0 1-.266.111.501.501 0 0 1-.184 0c-.069-.013-.135-.045-.266-.11L2 8.874Z'
      />
    </svg>
  );
};

export default NavExpertHelp;
